"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubCategorisationMifCorporationTrads = void 0;
exports.ESubCategorisationMifCorporationTrads = {
    professionnel: "Professionnel",
    non_professionnel: "Non professionnel",
};
